import React from 'react';
import { connect } from 'react-redux';
import { globalFieldLengths } from '@/constants/fields';
import DictionaryInput from '../../dictionaries/components/DictionaryInput';
import DictionaryFieldValue from './DictionaryFieldValue';
import DictionaryFieldContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/DictionaryFieldContainer';

const DictionaryFieldLabelTableCell = ({
  canEdit,
  canRead,
  code,
  category,
  dictionaryUUID,
  exists,
  fieldUUID,
  isEditing,
  label,
  template,
  updateProperties,
}) => (
  <>
    {isEditing && (
      <DictionaryFieldContainer category={category} code={code} exists={exists} canRead={canRead} canEdit={canEdit}>
        <DictionaryInput
          fluid
          text={label}
          type="field.label"
          maxLength={globalFieldLengths.dictionaryFieldLabel}
          onChange={(value) => updateProperties(category, code, dictionaryUUID, { label: value }, fieldUUID, template)}
        />
      </DictionaryFieldContainer>
    )}
    {!isEditing && (
      <DictionaryFieldValue category={category} code={code} value={label} canRead={canRead} canEdit={canEdit} />
    )}
  </>
);

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldLabelTableCell);
